import { useCallback, useEffect, useState } from 'react';

export function useHiddenColumns(storageKey) {
    const [hidden, setHidden] = useState(() => {
        try {
            const raw = window.localStorage.getItem(storageKey);
            const parsed = raw ? JSON.parse(raw) : [];
        return new Set(Array.isArray(parsed) ? parsed : []);
        } catch {
            return new Set();
        }
    });

    useEffect(() => {
        try {
            window.localStorage.setItem(storageKey, JSON.stringify([...hidden]));
        } catch {}
    }, [storageKey, hidden]);

    const hideColumn = useCallback((key) => {
        setHidden((prev) => {
            if (prev.has(key)) return prev;
            const next = new Set(prev);
            next.add(key);
            return next;
        });
    }, []);

    const showColumn = useCallback((key) => {
        setHidden((prev) => {
            if (!prev.has(key)) return prev;
            const next = new Set(prev);
            next.delete(key);
            return next;
        });
    }, []);

    const showAll = useCallback(() => {
        setHidden((prev) => (prev.size === 0 ? prev : new Set()));
    }, []);

    return { hidden, hideColumn, showColumn, showAll };
}